import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
    organization: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  // Handle typing in fields
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle Form Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    // ✅ YOUR FINAL PRODUCTION URL
    const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwy8UIO8-ZbcW8oUfclt-V74b6KOuTDEm7TbjcA72TQev0fdixy5FO9fmEOyzbA_XTSTw/exec";

    // Send data to Google Script using 'no-cors' mode
    fetch(GOOGLE_SCRIPT_URL, {
      method: "POST",
      body: JSON.stringify(formData),
      mode: 'no-cors', // IMPORTANT: This prevents browser security errors
      headers: {
        "Content-Type": "text/plain;charset=utf-8" // ✅ FIXED: This bypasses the CORS block
      }
    })
    .then(() => {
        // Since 'no-cors' doesn't return data, we assume success if no error happened
        setStatus('success');
        setFormData({
          user_name: '', user_email: '', organization: '', phone: '', message: ''
        });
        setTimeout(() => setStatus(''), 5000);
    })
    .catch((error) => {
        console.error("Error:", error);
        setStatus('error');
    });
  };

  return (
    <div className="contact-premium">
      <section className="contact-hero-premium">
        <div className="container">
          <span className="badge-glow">24/7 Support</span>
          <h1>Start Your Digital Transformation</h1>
          <p>Ready to deploy Smart QR Health? Let's discuss your facility's specific needs.</p>
        </div>
      </section>

      <section className="contact-content-premium">
        <div className="container">
          <div className="contact-grid-layout">
            
            {/* Left Column: Form */}
            <div className="form-card-glass">
              <h2>Send a Message</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input type="text" name="user_name" value={formData.user_name} onChange={handleChange} placeholder="Dr. John Doe" required />
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input type="email" name="user_email" value={formData.user_email} onChange={handleChange} placeholder="john@hospital.com" required />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Organization</label>
                    <input type="text" name="organization" value={formData.organization} onChange={handleChange} placeholder="Hospital Name" />
                  </div>
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="+91 98765 43210" />
                  </div>
                </div>

                <div className="form-group">
                  <label>Project Details *</label>
                  <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Tell us about your current challenges..." required></textarea>
                </div>

                <button type="submit" className="btn-primary full-width" disabled={status === 'sending'}>
                  {status === 'sending' ? 'Sending...' : 'Schedule Consultation'}
                </button>

                {status === 'success' && <p className="success-msg">✅ Message sent! Check your inbox for confirmation.</p>}
                {status === 'error' && <p className="error-msg">❌ Something went wrong. Please call us directly.</p>}
              </form>
            </div>

            {/* Right Column: Sidebar */}
            <div className="info-sidebar">
              <div className="info-card">
                <h3>Contact Information</h3>
                
                <div className="info-item">
                  <div className="icon">📧</div>
                  <div>
                    <span className="label" style={{ display: 'block', marginBottom: '5px' }}>Email Us</span>
                    <a href="mailto:info@sunrafinfotech.com">info@sunrafinfotech.com</a>
                  </div>
                </div>

                <div className="info-item">
                  <div className="icon">📞</div>
                  <div>
                    <span className="label" style={{ display: 'block', marginBottom: '5px' }}>Call Support</span>
                    <p>+91 7993325373</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="icon">🕒</div>
                  <div>
                    <span className="label" style={{ display: 'block', marginBottom: '5px' }}>Business Hours</span>
                    <p>Mon - Fri: 9:00 AM - 6:00 PM</p>
                    <p>Sat: 9:00 AM - 5:00 PM</p>
                    <p>Sun: 9:00 AM - 1:00 PM</p>
                  </div>
                </div>
              </div>

              <div className="trust-card">
                <h3>Why Partner With Us?</h3>
                <ul className="trust-list">
                  <li>✅ Zero-Downtime Deployment</li>
                  <li>✅ Dedicated Support Team</li>
                  <li>✅ Scalable Cloud Infrastructure</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;